import React, { PropTypes } from 'react';

const Loader = ({ size }) => (
  <div
    className={`loader-centering spinner ${size === 'medium' ? 'spinner-md' : 'spinner-lg'} is-auth0`}
  >
    <div className="circle" />
  </div>
);

Loader.defaultProps = {
  size: 'medium'
};

Loader.propTypes = {
  size: PropTypes.string
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js